export const ChartType = {
    area: 'Area',
    line: 'Line',
    bar: 'Bar',
    combine: 'Combine',
}
export default { ChartType }
